// removed by extract-text-webpack-plugin
module.exports = {"item":"item--1C8S2","itemInfo":"itemInfo--tDRsr","name":"name--2Iu3o","discount":"discount--E7kR_","soldOut":"soldOut--3TBvf","selected":"selected--12sBR"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/SearchBar/components/dropdownItem.scss
 ** module id = 614
 ** module chunks = 2 17
 **/